const MessageMediaType = {
  image: 'image',
  document: 'document',
};

export default MessageMediaType;
